"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemTypeToEquipmentSlot = void 0;
const enums_1 = require("../enums");
exports.ItemTypeToEquipmentSlot = {
    [enums_1.ItemType.None]: {},
    [enums_1.ItemType.Armor]: {
        [enums_1.EquipmentSlot.Armor]: true
    },
    [enums_1.ItemType.Necklace]: {
        [enums_1.EquipmentSlot.Necklace]: true
    },
    [enums_1.ItemType.TwoHandedWeapon]: {
        [enums_1.EquipmentSlot.MainHand]: true
    },
    [enums_1.ItemType.OneHandedWeapon]: {
        [enums_1.EquipmentSlot.MainHand]: true,
        [enums_1.EquipmentSlot.OffHand]: true
    },
    [enums_1.ItemType.Shield]: {
        [enums_1.EquipmentSlot.OffHand]: true
    },
    [enums_1.ItemType.Ring]: {
        [enums_1.EquipmentSlot.Ring1]: true,
        [enums_1.EquipmentSlot.Ring2]: true
    },
    [enums_1.ItemType.OffHandItem]: {
        [enums_1.EquipmentSlot.OffHand]: true
    },
    [enums_1.ItemType.CharacterSkin]: {
        [enums_1.EquipmentSlot.Skin]: true
    },
    [enums_1.ItemType.Helmet]: {
        [enums_1.EquipmentSlot.Head]: true
    },
    [enums_1.ItemType.Hat]: {
        [enums_1.EquipmentSlot.Head]: true
    },
    [enums_1.ItemType.Charm]: {
        [enums_1.EquipmentSlot.Charm0]: true
    },
    [enums_1.ItemType.Consumable]: {}
};
